// extracted by mini-css-extract-plugin
export default {"products":"nt-z","card":"ot-z","oosMessaging":"pt-z"};